import { message } from 'antd';

import api from '@/api';

import { approximationTypes } from '@/components/MiningAndPumping/SummaryMode/Drawer/Approximation/constants';

const ABORT_ERROR_CODE = 20;
let kyController = new AbortController();

const approximationModel = {
    name: 'approximation',
    state: {
        data: null,
        types: approximationTypes,
        selectedIndicator: null,
        firstDate: null,
        secondDate: null,
        forecastPeriod: 0,
        autoMode: false,
        loading: false,
    },
    reducers: {
        setData(state, payload) {
            return {
                ...state,
                data: payload,
            };
        },
        setTypes(state, payload) {
            return {
                ...state,
                types: payload,
            };
        },
        setLoading(state, payload) {
            return {
                ...state,
                loading: payload,
            };
        },
        setFirstDate(state, payload) {
            return {
                ...state,
                firstDate: payload,
            };
        },
        setSecondDate(state, payload) {
            return {
                ...state,
                secondDate: payload,
            };
        },
        setForecastPeriod(state, payload) {
            return {
                ...state,
                forecastPeriod: payload,
            };
        },
        setSelectedIndicator(state, payload) {
            return {
                ...state,
                selectedIndicator: payload,
            };
        },
        setAutoMode(state, payload) {
            return {
                ...state,
                autoMode: payload,
            };
        },
    },

    effects: () => ({
        cancelRequest() {
            kyController.abort();
            kyController = new AbortController();

            this.setLoading(false);
        },

        async fetchData(payload) {
            this.setLoading(true);
            try {
                const data = await api.miningAndPumping.fetchApproximationSummary({
                    json: payload,
                    signal: kyController.signal,
                });
                if (Object.keys(data) < 1) {
                    message.info('Недостаточно данных для построения графика в режиме "Аппроксимация"');
                } else {
                    this.setData(data);
                }
            } catch (error) {
                console.error(error);
                this.setData(null);
                if (error.code === ABORT_ERROR_CODE) return;

                message.error('Не удалось получить данные для режима "Аппроксимация"');
            }
            this.setLoading(false);
        },
    }),
};

export default approximationModel;
